import React from "react";
import { Link } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-50">
      <h1 className="text-9xl font-extrabold text-red-500">404</h1>
      <p className="text-2xl text-gray-700 mt-4">
        Oops! The page you're looking for doesn't exist.
      </p>
      <p className="text-lg text-gray-600 mt-2">
        It seems you’ve found a broken link or entered a wrong URL.
      </p>
      <Link
        to="/"
        className="mt-6 px-6 py-3 bg-blue-600 text-white text-lg font-semibold rounded-lg shadow-md hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
      >
        Go Back Home
      </Link>
    </div>
  );
};

export default NotFoundPage;
